<template>
  <div class="tPassDetailContent">
    <div>
      <div class="tr-header">
        <div class="tr-content-item">
          <div class="tr-item">
            <div class="th-title">項目名稱</div>
            <div class="td-text">{{ TPassdetailData.piName }}</div>
          </div>
          <div class="tr-item">
            <div class="th-title">收據號碼</div>
            <div class="td-text">{{ TPassdetailData.rpPublicNo }}</div>
          </div>
          <div class="tr-item">
            <div class="th-title">繳費金額</div>
            <div class="td-text">${{ TPassdetailData.rpArAmt | currencyFormat }}</div>
          </div>
          <div class="tr-item">
            <div class="th-title">優免金額</div>
            <div class="td-text">${{ TPassdetailData.rpDicountAmt | currencyFormat }}</div>
          </div>
          <div class="tr-item">
            <div class="th-title">實收金額</div>
            <div class="td-text text-primary real-amt">
              ${{ TPassdetailData.rpRealAmt | currencyFormat }}
            </div>
          </div>

          <!-- <div class="tr-item">
            <div class="th-title">狀態</div>
            <div class="td-text">{{ TPassdetailData.rpStatusName }}</div>
          </div> -->
        </div>
      </div>
      <div class="tr-content">
        <div class="tr-item">
          <div class="th-title">開立明細</div>
          <div class="td-text" >
            <img
              v-if="!isShowDetailsAll"
              class="vertical-text-top"
              src="@/assets/images/tp-down-arrow.png"
              alt="tp-down-arrow"
              @click="switchDetail()"
            />
            <img
              v-if="isShowDetailsAll"
              class="vertical-text-top"
              src="@/assets/images/tp-up-arrow.png"
              alt="tp-up-arrow"
              @click="isShowDetailsAll = false"
            />
          </div>
        </div>
        <div class="tr-content-item" v-if="isShowDetailsAll">
          <div class="tr-item">
            <div class="th-title">開立機關</div>
            <div class="td-text">{{ TPassdetailData.ogName }}</div>
          </div>
          <div class="tr-item">
            <div class="th-title">開立日期</div>
            <div class="td-text">{{ TPassdetailData.rpOpenDate | TWDateFormat('YYYY/MM/DD') }}</div>
          </div>
        <!-- </div> -->
        <!-- <div class="tr-content-item" v-if="isShowDetailsAll && isDownloadPdf"> -->
          <div class="tr-item">
            <div class="th-title">收據日期</div>
            <div class="td-text">{{ TPassdetailData.rpDate | TWDateFormat('YYYY/MM/DD') }}</div>
          </div>
          <div class="tr-item">
            <div class="th-title">繳款機關/繳款人</div>
            <div class="td-text">{{ TPassdetailData.rpPayManName }}</div>
          </div>
          <div class="tr-item">
            <div class="th-title">繳款方式</div>
            <div class="td-text">{{ TPassdetailData.pmName }}</div>
          </div>
          <div class="tr-item">
            <div class="th-title">印花稅總繳</div>
            <div class="td-text">{{ TPassdetailData.rpIsStampDuty === 'Y' ? '有' : '無' }}</div>
          </div>
          <div class="tr-item">
            <div class="th-title">預開收據</div>
            <div class="td-text">{{ TPassdetailData.rpIsPreOpen === 'Y' ? '有' : '無' }}</div>
          </div>
        </div>
      </div>
      <div class="tr-footer" v-if="isShowDetailsAll">
        <div class="tr-item">
          <div class="th-title">經辦人員</div>
          <div class="td-text">{{ TPassdetailData.rpOperatorName }}</div>
        </div>
        <div class="tr-item">
          <div class="th-title">主辦出納</div>
          <div class="td-text">{{ TPassdetailData.rpCashierName }}</div>
        </div>
        <div class="tr-item">
          <div class="th-title">主辦會計</div>
          <div class="td-text">{{ TPassdetailData.rpAccountName }}</div>
        </div>
        <div class="tr-item">
          <div class="th-title">備註</div>
        </div>
        <div class="tp-remark">
          <b-textarea
            id="form-memo"
            ref="formMemo"
            :value="TPassdetailData.rpRemark"
            rows="3"
            max-rows="3"
            readonly
            class="bg-gray-500"
          />
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'TPassReceiptDetailContent',

  props: {
    TPassdetailData: {
      type: Object,
      default: () => {},
    },
    // isShowDetailsAll: {
    //   type: Boolean,
    //   default: false,
    // },
    isDownloadPdf: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isShowDetailsAll: true,
    }
  },

  created() {
    $('#app').css('padding-top', '0px');
    $('.tpass-detail-container').css('margin-top', '0px');
  },

  methods: {
    switchDetail() {
      console.log('switchDetail');
      this.isShowDetailsAll = true
    }
  }
};
</script>
